import React from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';
import { BUSINESS_NAME, BUSINESS_ADDRESS, BUSINESS_EMAIL, BUSINESS_LOGO } from '../constants/business';

function invoiceNumber(cartId) {
  const datePart = new Date().toISOString().slice(0, 10).replace(/-/g, '');
  const shortId = (cartId || '').replace(/-/g, '').slice(0, 8).toUpperCase();
  return `PI-${datePart}-${shortId || 'DRAFT'}`;
}

class InvoicePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      total: 0,
      cartId: null,
      loading: true,
      billToName: props.customer?.fullName || '',
      billToEmail: props.customer?.email || ''
    };
  }

  componentDidMount() {
    api.getCart()
      .then((cart) => this.setState({ items: cart.items, total: cart.total, cartId: cart.cartId, loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  handlePrint = () => window.print();

  render() {
    const { items, total, cartId, loading, billToName, billToEmail } = this.state;
    if (loading) return <p className="loading">Loading...</p>;

    if (!items.length) {
      return (
        <div className="invoice-page">
          <p>Your cart is empty. <Link to="/products">Browse licenses</Link> to add something first.</p>
        </div>
      );
    }

    const today = new Date().toLocaleDateString('en-NG', { year: 'numeric', month: 'long', day: 'numeric' });

    return (
      <div className="invoice-page">
        <div className="invoice-toolbar no-print">
          <div className="invoice-billto-fields">
            <input
              placeholder="Customer name (optional, for this printout)"
              value={billToName}
              onChange={(e) => this.setState({ billToName: e.target.value })}
            />
            <input
              placeholder="Customer email (optional, for this printout)"
              value={billToEmail}
              onChange={(e) => this.setState({ billToEmail: e.target.value })}
            />
          </div>
          <div className="invoice-toolbar-actions">
            <button className="btn" onClick={this.handlePrint}>Print / Save as PDF</button>
            <Link to="/checkout" className="btn btn-primary">Proceed to checkout</Link>
          </div>
        </div>

        <div className="invoice-sheet">
          <div className="invoice-header">
            <img src={BUSINESS_LOGO} alt={BUSINESS_NAME} className="invoice-logo" />
            <div className="invoice-business-info">
              <strong>{BUSINESS_NAME}</strong>
              <span>{BUSINESS_ADDRESS}</span>
              <span>{BUSINESS_EMAIL}</span>
            </div>
          </div>

          <div className="invoice-title-row">
            <div>
              <h1>Proforma Invoice</h1>
              <p className="invoice-subtext">This is a quote of items in your cart — not a receipt. A confirmed receipt and license key(s) follow by email once payment clears.</p>
            </div>
            <div className="invoice-meta">
              <div><span>Invoice No.</span><strong>{invoiceNumber(cartId)}</strong></div>
              <div><span>Date</span><strong>{today}</strong></div>
            </div>
          </div>

          {(billToName || billToEmail) && (
            <div className="invoice-billto">
              <span>Bill To</span>
              {billToName && <strong>{billToName}</strong>}
              {billToEmail && <span>{billToEmail}</span>}
            </div>
          )}

          <table className="invoice-table">
            <thead>
              <tr><th>License</th><th>Type</th><th>Qty</th><th>Unit Price</th><th>Line Total</th></tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td>{item.license_type === 'shared' ? 'Shared' : 'Private'}</td>
                  <td>{item.quantity}</td>
                  <td>₦{Number(item.unit_price).toLocaleString()}</td>
                  <td>₦{Number(item.line_total).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr><td colSpan={4}>Total</td><td>₦{Number(total).toLocaleString()}</td></tr>
            </tfoot>
          </table>

          <p className="invoice-footnote">
            Prices are in Nigerian Naira (₦). Payment accepted via Paystack or Squad by GTCO. This
            document does not confirm payment or license delivery.
          </p>
        </div>
      </div>
    );
  }
}

export default InvoicePage;
